<template>
    <form class="kt-form" @submit.prevent="edit" id="marketing_setting">
        <kt-row lg="12" md="12" xs="12">
            <kt-col class="col-lg-6 col-md-6 col-sm-6">
                <kt-form-section>
                    <kt-form-group >
                        <kt-form-label for="marketing_level_1">
                            {{ $t('marketing.marketing_setting.level_1') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                placeholder="0-100"
                                name="marketing_level_1"
                                id="marketing_level_1"
                                max="100"
                                v-model="marketing_setting.percent_setting.profit_percent_level_1"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-form-section>
            </kt-col>
        </kt-row>
        <kt-row>
            <kt-col class="col-lg-6 col-md-6 col-sm-6">
                <kt-form-group >
                    <kt-form-label for="marketing_level_2">
                        {{ $t('marketing.marketing_setting.level_2') }}
                    </kt-form-label>
                    <kt-form-control
                            type="number"
                            placeholder="0-100"
                            name="marketing_level_2"
                            id="marketing_level_2"
                            max="100"
                            v-model="marketing_setting.percent_setting.profit_percent_level_2"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col class="col-lg-6 col-md-6 col-sm-6">
                <kt-form-group>
                    <kt-form-label for="transaction_for_level_2">
                        {{ $t('marketing.marketing_setting.transaction_for_level_2') }}
                    </kt-form-label>
                    <kt-form-control
                            type="number"
                            placeholder="1,000,000"
                            name="transaction_for_level_2"
                            id="transaction_for_level_2"
                            v-model="marketing_setting.percent_setting.marketing_transaction_level_2"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
        </kt-row>
        <kt-row>
            <kt-col class="col-lg-6 col-md-6 col-sm-6">
                <kt-form-group>
                    <kt-form-label for="marketing_level_3">
                        {{ $t('marketing.marketing_setting.level_3') }}
                    </kt-form-label>
                    <kt-form-control
                            type="number"
                            placeholder="0-100"
                            name="marketing_level_3"
                            id="marketing_level_3"
                            max="100"
                            v-model="marketing_setting.percent_setting.profit_percent_level_3"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
            <kt-col class="col-lg-6 col-md-6 col-sm-6">
                <kt-form-group>
                    <kt-form-label for="transaction_for_level_3">
                        {{ $t('marketing.marketing_setting.transaction_for_level_3') }}
                    </kt-form-label>
                    <kt-form-control
                            type="number"
                            placeholder="100,000"
                            name="transaction_for_level_3"
                            id="transaction_for_level_3"
                            v-model="marketing_setting.percent_setting.marketing_transaction_level_3"
                    >
                    </kt-form-control>
                </kt-form-group>
            </kt-col>
        </kt-row>

        <kt-form-action class="mt-4" v-if="$can('change-settings','marketing')">
            <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                {{ $t('btn.edit') }}
            </button>
        </kt-form-action>
    </form>
</template>

<script>
import $ from 'jquery'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import {marketingService} from "@/common/api.service";

export default {
    methods: {
        edit(e) {
            let btn = $('#submit_btn')
            let form = $('#marketing_setting')


            form.validate( {
                rules: {
                    marketing_level_1: {
                        required: true
                    },
                    marketing_level_2: {
                        required: true
                    },
                    transaction_for_level_2: {
                        required: true
                    },
                    marketing_level_3: {
                        required: true
                    },
                    transaction_for_level_3: {
                        required: true
                    },
                }
            })

            if(!form.valid()) {
                return
            }
            KTApp.progress(btn)
            let params = {
                profit_percent_level_1: this.marketing_setting.percent_setting.profit_percent_level_1,
                profit_percent_level_2: this.marketing_setting.percent_setting.profit_percent_level_2,
                profit_percent_level_3: this.marketing_setting.percent_setting.profit_percent_level_3,
                marketing_transaction_level_2: this.marketing_setting.percent_setting.marketing_transaction_level_2,
                marketing_transaction_level_3: this.marketing_setting.percent_setting.marketing_transaction_level_3,
            }
            marketingService.changeMarketingSetting(params)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })
        },
    },
    props: {
        marketing_setting: {
            required: true
        },
    },
}
</script>

<style>

</style>